import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService, AppStateService, HttpService, EnvService, UtilsService } from 'usermgmt';
import { PROJECT_CONSTANTS } from '../../../constants/proj.cnst';
import { isNullOrUndefined,PermissionsService } from 'shared-library';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class ApplicationGuard implements CanActivate {
  userPermissions: any;

  constructor(
    private authSrv: AuthenticationService,
    private router: Router,
    private appStateSrv: AppStateService,
    private httpSrv: HttpService,
    private envService : EnvService,
    private utilService: UtilsService,
    private permissionsService: PermissionsService,
    protected readonly keyCloakSrv: KeycloakService,
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree | any> {
    
    const loggedIn = this.authSrv.isLoggedIn() || await this.keyCloakSrv.isLoggedIn();;
    if (!loggedIn) {  
      this.utilService.logout();
      return false;
    }

     //* Extract the token from keycloak
       const accessToken = await this.authSrv.getAccessToken();
    if (!accessToken) {
      return this.handleUnAuthorizedAccess("Session expired. Please log in again.", ['username']);
    }
    const userId = this.authSrv.getUserId() ?? localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') as string).userId : null;
    let hasPermissionsLoaded = this.appStateSrv.getPermissionsLoaded();
    const applicationName = PROJECT_CONSTANTS.APPLICATION_NAME;
    const usermgmtAppName = PROJECT_CONSTANTS.USERMGMT_APP_NAME;
    this.userPermissions = this.appStateSrv.getUserPermissions();
    if(Object.keys(this.userPermissions).length > 0){
      this.permissionsService.setPermissions(this.userPermissions);
    }
    
    if (hasPermissionsLoaded) {
      if(Object.keys(this.userPermissions).length > 0 && Object.keys(this.userPermissions).includes(applicationName)) {
        return this.checkPermissions(state.url);
      }else if(Object.keys(this.userPermissions).includes(usermgmtAppName)) {
         const umPermisions = this.userPermissions[usermgmtAppName].resources;
       if(umPermisions['USER']){
           this.router.navigate(['um','users']);
        }else if(umPermisions['ROLE']){
           this.router.navigate(['um','roles']);
        }
        else if(umPermisions['APPLICATION']){
          this.router.navigate(['um','applications']);
        }else{
          this.router.navigate(['', 'access-denied']);
        }
      }   
      return false;
    }else {
      console.log("Fetching user permissions from login component");
      this.appStateSrv.setInProcess(true);
      let options = { uriParams: { userId } };
      return new Promise((resolve, reject) => {
        this.httpSrv.makeGetApiCall('GET_USER_PERMISSIONS',this.envService.baseUrl, options).subscribe({
          next: (res: any) => {
            if (!isNullOrUndefined(res.response)) {
              localStorage.setItem("customerInfo",JSON.stringify(res.response.meta));
              this.userPermissions = res.response && res.response.permissions ? res.response.permissions : {};
              this.permissionsService.setPermissions(this.userPermissions);
              let metaInfo = res.response && res.response.meta ? res.response.meta : {};
              this.appStateSrv.setUserMetaInfo(metaInfo);
              this.appStateSrv.setInProcess(false);
              this.appStateSrv.setPermissionsLoaded(true);
              this.appStateSrv.setUserPermissionsRef(this.userPermissions);
              
              if(Object.keys(this.userPermissions).length > 0 && Object.keys(this.userPermissions).includes(applicationName)) {
                if(this.checkPermissions(state.url)) {
                  resolve(true);
                }else {
                  resolve(this.handleUnAuthorizedAccess());
                }
              } else if(Object.keys(this.userPermissions).includes(usermgmtAppName)) {
                resolve(true);
                // resolve(this.handleUnAuthorizedAccess("You don't have permissions to view the requested Application", ['um','applications']));
              }else {
                resolve(this.handleUnAuthorizedAccess());
              }
            } else {
              resolve(this.handleUnAuthorizedAccess());
            }
          },
          complete: () => {},
          error: () => { resolve(this.handleUnAuthorizedAccess()); }
        });
      })
    }
  }

  handleUnAuthorizedAccess(message: string = "You don't have permissions to view the requested resource", route: string[] = ['', 'login']) {
    // this.dataService.showToastMessage(message, "error");
    // this.router.navigate(route);
    return false;
  }

  // TODO: Refactor this. Move all the constants to proj.cnst file
  checkPermissions(resource: string) {
    if(resource) {
      
      if(this.userPermissions[PROJECT_CONSTANTS.APPLICATION_NAME]['userRoleScope']?.['scope'].length > 0 && 
        this.userPermissions[PROJECT_CONSTANTS.APPLICATION_NAME]['userRoleScope']['scope'][0].scopeValue.length > 0 &&
        this.userPermissions[PROJECT_CONSTANTS.APPLICATION_NAME]['userRoleScope']['scope'][0].scopeValue[0] == '*') {
          // if(RESOURCES_EXCLUDED_FROM_SUPERADMIN.includes(resource)){
          //   this.router.navigate(['home']);
          //   return false;
          // }
        return true;
      }else {
        if(this.userPermissions[PROJECT_CONSTANTS.APPLICATION_NAME].resources) {
          const dashboardResource: any[] = [];
          for(const resource of Object.keys(this.userPermissions[PROJECT_CONSTANTS.APPLICATION_NAME].resources)) {
            if(this.userPermissions[PROJECT_CONSTANTS.APPLICATION_NAME].resources && this.userPermissions[PROJECT_CONSTANTS.APPLICATION_NAME].resources[resource].resourceTypeName == 'Dashboards') {
              dashboardResource.push(resource);
            }
          }
          
          for(let application_resource of dashboardResource) {          
            const resourceName = resource.replace(' ', '').toLowerCase();
            if(resourceName.includes(application_resource.toLowerCase()) || application_resource == '*') {
              return true;
            }
          }
        }
      }
    }
    return false;
  }
}
